export { default } from '@shikijs/langs/java'
